import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import WhyChooseUsSection from "./components/WhyChooseUsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AboutSection from "./components/AboutSection";
import RealResultsSection from "./components/RealResultsSection";
import ContactSection from "./components/ContactSection";
import SEO from "../../utils/seo";

const Home = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Starlight Motors Mobile Detailing",
    "description": "Professional mobile car detailing service in Melbourne offering full interior & exterior detailing, ceramic coating, and paint correction",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Melbourne",
      "addressRegion": "VIC",
      "addressCountry": "AU"
    },
    "telephone": "0491121950",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://starlightmotors.com.au'}`,
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": -37.8136,
        "longitude": 144.9631
      },
      "geoRadius": "50000"
    },
    "priceRange": "$170-$600",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Car Detailing Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Basic Wash & Vacuum",
            "description": "Exterior wash, interior vacuum, and basic cleaning"
          },
          "price": "170",
          "priceCurrency": "AUD"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Premium Detail",
            "description": "Complete interior and exterior detailing with protection"
          },
          "price": "250",
          "priceCurrency": "AUD"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Ceramic Coating",
            "description": "Professional ceramic coating application for long-lasting protection"
          },
          "price": "600",
          "priceCurrency": "AUD"
        }
      ]
    },
    "openingHours": "Mo-Sa 07:00-18:00, Su 09:00-16:00",
    "sameAs": [
      "https://www.instagram.com/starlightmotors_/",
      "https://www.facebook.com/people/Starlightmotors-mobile-detailing/61573939679933/"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "47"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Sarah Johnson"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5"
        },
        "reviewBody": "Absolutely amazing service! My car looks brand new after their ceramic coating treatment. The team was professional and punctual."
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Michael Chen"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5"
        },
        "reviewBody": "Best mobile detailing service in Melbourne! They came to my office and did an incredible job. Highly recommend their premium package."
      }
    ]
  };

  return (
    <>
      <SEO
        title="Premium Mobile Car Detailing Melbourne | Starlight Motors"
        description="Professional mobile car detailing in Melbourne. We come to you! Full interior & exterior detailing, ceramic coating, paint correction. Book Starlight Motors today for showroom shine at your location."
        keywords="mobile car detailing Melbourne, car detailing service, ceramic coating Melbourne, paint correction, mobile auto detailing"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://starlightmotors.com.au'}/`}
        ogTitle="Premium Mobile Car Detailing Melbourne | Starlight Motors"
        ogDescription="Professional mobile car detailing in Melbourne. We come to you! Full interior & exterior detailing, ceramic coating, paint correction. Book Starlight Motors today for showroom shine at your location."
        ogImage={`${import.meta.env.VITE_SITE_URL || 'https://starlightmotors.com.au'}/og-image.jpg`}
        structuredData={structuredData}
      />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <h1 className="sr-only">Starlight Motors Mobile Detailing - Professional Car Detailing Melbourne</h1>
          <HeroSection />
          <WhyChooseUsSection />
          <ServicesSection />
          <RealResultsSection />
          <TestimonialsSection />
          <AboutSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Home;
